module.exports = __webpack_public_path__ + "img/num1.1ac9ad38.png";